import React from 'react';
import './notFound.css'

export default class NotFound extends React.Component {
    render() {
        return (
            <div>
                <section className="content">
                    <div className="error-page">
                        <h2 className="headline text-yellow"> 404</h2>
                        <div className="error-content">
                            <h3><i className="fa fa-warning text-yellow"></i> Упс! Страница не найдена.</h3>
                            <p>Мы не нашли страницу, которую вы запросили.</p>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
};


// WEBPACK FOOTER //
// ./App/pages/notFound/notFound.jsx